import {
    getDataFromLFStorage,
    initiateLFStorage,
    LFStorageKeys,
    setAllBotsForSelectedDomainInLFStorage,
    updateBotForSelectedDomainInLFStorage
} from "../../services/storage/LFStorage";
// import { UserServiceClientApi } from '../../services/api/UserApiServices';
// import { storeAuthData } from "../../services/storage/LocalStorage";
// import { BOT_SUBSCRIPTIONS_RECEIVED, LOGOUT_USER, USER_LOGGED_IN, UPDATE_USER_DOMAIN_ROLES, SELECTED_DOMAIN, DOMAIN_RECEIVED, UPDATE_USER, USER_PROFILE_IMAGE, UPDATE_SOFTWARE_MFA, UPDATE_SOFTWARE_MFA_STATUS, UPDATE_MFA_STATUS, UPDATE_QR_CODE_URI, UPDATE_PHONE_BALANCE, UPDATE_BANNER } from "../constants";
import { setSelectedBot } from "./domain";
import { cloneDeep, remove } from "lodash";
import { IM_BOT, SEAMEDEX_TYPE, VIKAND, VIKAND_DIRECT, VIKAND_DIRECT_STAGE } from "../../utils/constants";
import { getAuthData, storeAuthData, getFromLocalStorage, saveInLocalStorage, setUserOnline, getSessinIdFromLS } from "../../services/storage/LocalStorage";
import { BOT_SUBSCRIPTIONS_RECEIVED, LOGOUT_USER, USER_LOGGED_IN, UPDATE_USER_DOMAIN_ROLES, SELECTED_DOMAIN, DOMAIN_RECEIVED, UPDATE_USER, USER_PROFILE_IMAGE, UPDATE_LOGGED_IN_USER_CALL_HISTORY, UPDATE_BANNER, UPDATE_SELECTED_CONTACT_CALL_HISTORY, CLEAR_LOGGED_IN_USER_CALL_HISTORY, UPDATE_SOFTWARE_MFA, UPDATE_SOFTWARE_MFA_STATUS, UPDATE_MFA_STATUS, UPDATE_QR_CODE_URI, UPDATE_PHONE_BALANCE, USER_ONLINE_STATUS, GET_FAVOURITES, GENERATING_PUSH_NOTIFICATIONS, DE_GENERATING_PUSH_NOTIFICATIONS, SET_CONNECTION_ID } from "../constants";
import { createChatBotConversation, streamChatMessages } from "./chats";
import { getCallHistoryForSelectedContact, getPaginatedCallHistory } from "../../services/VoipServices";
import { UserServiceClientApi } from "../../services/api/UserApiServices";
import { setBannerVisibility } from "./offlineBanner";
import { setTabState } from "./tabStack";
import { parseFavourites } from "../../utils/Helpers";
import Config from '../../utils/config/config'
import axios from "axios";
import webSocketApiService from "../../services/socket/wsApiServices";

export const setLoggedUserDetails = (user, isAnonymousUser = false) => {
    if (!user) return { type: USER_LOGGED_IN, data: null };
    const authDetails = getAuthData();
    const sessionID = getSessinIdFromLS();
    const { user: userDetails,newUser } = user || authDetails;
    // Use fallback logic correctly for destructuring
    const sessionId = user?.sessionId || sessionID;

    // This assumes user is available before calling this
    initiateLFStorage(userDetails);

    const authData = {
        user: userDetails,
        auth: {
            sessionId: sessionId,
            newUser: newUser || false
        },
        isAnonymousUser,
    };

    storeAuthData(authData);
    return {
        type: USER_LOGGED_IN,
        data: authData,
    };
};

export const setUpdateLoggedUserDetails = (authData, isAnonymousUser = false) => {
    if (!authData) return { type: USER_LOGGED_IN, data: null };

    const { auth, user } = authData;
    const updatedAuthData = {
        user,
        auth,
        isAnonymousUser,
    };
    return {
        type: USER_LOGGED_IN,
        data: updatedAuthData,
    };
};


export const updateUserProfile = (data) => {
    return {
        type: UPDATE_USER,
        data: { user: data },
    };
};

export const setUserProfileImage = (payload) => ({
    type: USER_PROFILE_IMAGE,
    payload,
});


export const fetchBotSubscriptions = (
    domain,
    botId = null,
    forceUpdate = false,
    updateNow,
    type = ""
) => {
    return async (dispatch, getState) => {
        try {
            const selectedDomain = domain.userDomain || "";
            const { user } = getAuthData();
            let botsList = await getDataFromLFStorage(selectedDomain);

            // Fetch from API if no bots or force update
            if (!botsList?.length || forceUpdate) {
                const response = await fetchSubscribedBots(dispatch, selectedDomain, botId, domain);
                if (response) botsList = updateNow ? response : botsList;
            }
            // Sort alphabetically by name
            if (Array.isArray(botsList)) {
                botsList.sort((a, b) => a?.botName?.localeCompare(b?.botName));
            }

            const prevDomain = await getFromLocalStorage(LFStorageKeys.SELECTED_DOMAIN);
            const savedSelectedBot = await getFromLocalStorage(LFStorageKeys.SELECTED_BOT);
            const currentDomainName = domain.name;
            const selectedBotDetails = getState().domain.selectedBotDetails;
            const isSameDomain = prevDomain === currentDomainName;
            let firstBot = null;
            if (Array.isArray(botsList)) {
                if (domain?.landingBotId) {
                    firstBot = botsList?.find((bot) => bot.botId === domain?.landingBotId)
                }
                dispatch(setTabState(true))
            } else
                if (botsList && typeof botsList === 'object') {
                    firstBot = botsList; // single object case
                }

            if (isSameDomain) {
                // Re-entering the same domain: load saved bot or state-selected one
                if (savedSelectedBot && typeof savedSelectedBot === 'string') {
                    try {
                        dispatch(setSelectedBot(JSON.parse(savedSelectedBot)));
                    } catch (err) {
                        console.error('Error parsing saved bot data:', err);
                    }

                } else if (selectedBotDetails) {
                    dispatch(setSelectedBot(selectedBotDetails));
                } else {

                    dispatch(setSelectedBot(firstBot));
                    dispatch(createChatBotConversation(firstBot, user?.userId));
                    if (window.location.pathname === '/app/chats') {
                        const activeItemValue = `App Marketplace-${firstBot?.botName}`;
                        // saveInLocalStorage(LFStorageKeys.ACTIVE_ITEM, activeItemValue);
                    }
                }
            } else {
                // First time loading a new domain
                dispatch(setSelectedBot(firstBot));
                dispatch(createChatBotConversation(firstBot, user?.userId));

                // Save active item in localStorage if on /app/chats
                if (window.location.pathname === '/app/chats') {
                    const activeItemValue = `App Marketplace-${firstBot?.botName}`;
                    // saveInLocalStorage(LFStorageKeys.ACTIVE_ITEM, activeItemValue);
                }
            }

            dispatch({
                type: BOT_SUBSCRIPTIONS_RECEIVED,
                data: { botSubscriptions: botsList },
            });
        } catch (error) {
            console.error("Error in fetchBotSubscriptions: ", error);
        }
    };
};



const fetchSubscribedBots = async (dispatch, selectedDomain, botId, domainData) => {
    try {
        const response = await webSocketApiService.GetBotSubscriptionsInfo(selectedDomain);
        if (response.error === 0) {
            const responseBotList = (response?.content?.subscribed || []).filter(bot => !bot.systemBot && !bot.botClients.web === false);
            if (responseBotList.length) {
                const params = {
                    isWebRequest: true,
                    query: "",
                    selectedDomain: selectedDomain,
                }
                const response = await webSocketApiService.GetCatalog(params);
                if (response.data) {
                    const bots = response.bots || [];
                    if (bots && bots.length > 0) {
                        for (let i in bots) {
                            for (let b in responseBotList) {
                                if (responseBotList[b].botId === bots[i].botId) {
                                    responseBotList[b]["chatButtonHidden"] = bots[i].chatButtonHidden ?? false
                                }
                            }
                        }
                    }
                };
       
                dispatch({
                    type: BOT_SUBSCRIPTIONS_RECEIVED,
                    data: { botSubscriptions: responseBotList },
                });

                if (botId !== null) {
                    const filteredBot = responseBotList.find((bot) => bot.botId === botId);

                    if (filteredBot) {
                        filteredBot.subscribed = true;
                        await updateBotForSelectedDomainInLFStorage(selectedDomain, filteredBot);
                        // setBotsDependenciesList([filteredBot]);
                    }
                } else {
                    await setAllBotsForSelectedDomainInLFStorage(selectedDomain, responseBotList);
                    // setBotsDependenciesList(responseBotList);
                }
            }
            try {
                let response2 = await webSocketApiService.GetFavouriteConversations({selectedDomain});
                response2 = response2 ? { data: response2 } : {};
                if (response2) {
                    let newFav = { ...response2.data };
                    const favourites = parseFavourites(response2.data, responseBotList);
                    dispatch({
                        type: GET_FAVOURITES,
                        data: { getFavourites: { ...newFav, favourites } },
                    });
                }

            } catch (error) {
                console.error("Error fetching favourite bots: ", error);
            }


            return responseBotList;
        } else {
            dispatch({
                type: BOT_SUBSCRIPTIONS_RECEIVED,
                data: { botSubscriptions: [] },
            });
        }
    } catch (error) {
        console.error("Error fetching subscribed bots: ", error);
    }
    return null;
};

export const updateUserRoles = (data) => {
    return (dispatch, getState) => {
        let user = { ...getState()?.user?.user };
        let domain = data.data?.content[data?.data?.content.length - 1];
        // Here we set the new domains and userRoles received in UserService/SubscribeDomain API
        user.domains = data?.data?.content.map((x) => ({ roles: x.roles, domain: x.userDomain }));
        dispatch({
            type: UPDATE_USER_DOMAIN_ROLES,
            data: user,
        });
        // Here we set the newly added domain for fetchBotSubscriptions
        // dispatch({
        // 	type: SELECTED_DOMAIN,
        // 	data: { selectedDomain: data?.data?.content[data?.data?.content.length - 1].userDomain, selectedDomainDetails: data?.data?.content[data?.data?.content.length - 1] },
        // });
        // To also get the default bots for new domain & new user workflow
        // dispatch(fetchBotSubscriptions(domain, null, true, true));
    };
};

export async function fetchWalletBalance() {
    const data = {
        parameters: JSON.stringify({
            action: "getSpecificQuota",
            botId: "pstn-balance",
        }),
        capability: "MessageQuotaCapability",
        conversation: {
            conversationId: "fetch_balance",
            bot: IM_BOT,
            participants: ["AgentM"],
        },
        sync: true,
    };
    try {
        const response = await webSocketApiService.AgentGuardService(data);
        let available = 0;
        if (response) {
            const parsedContent = JSON.parse(response.content[0]);
            const pstn = parsedContent["pstn-balance"]
            if (pstn?.available) {
                available = Math.ceil(pstn?.available * 1000) / 1000;
            }
        }
        return available;
    } catch (error) {
        console.error("Cannot fetch wallet balance", error);
        return 0;
    }
}



export const fetchWalletBalanceService = () => (dispatch) => {
    fetchWalletBalance()
        .then((balance) => {
            dispatch(
                setPhoneBalance({
                    balance,
                })
            );
        })
        .catch((error) => {
            console.error("Cannot fetch wallet balance", error);
        });
};

const setAllDomains = (domainsList, dispatch) => {
    // dispatch(removeSelectedDomain());
    let isLastLogin = false;
    let lastLoginDomain = null;

    domainsList.forEach((elem) => {
        if (elem && elem.lastLoggedIn) {
            isLastLogin = true;
            lastLoginDomain = elem;
        }
    });

    let lastLoggedInDomain = cloneDeep(lastLoginDomain);
    let responseDomain = cloneDeep(domainsList[0]);

    if (lastLoggedInDomain && lastLoggedInDomain.lockInUsers) {
        //when lockInUsers true dropdown will show the Plus but hiding frontm.ai
        let allDomains = cloneDeep(domainsList);
        remove(allDomains, (domain) => {
            return domain.userDomain === "frontmai";
        });
        domainsList = allDomains;
    }

    if (isLastLogin) {
        dispatch({
            type: SELECTED_DOMAIN,
            data: { selectedDomain: lastLoggedInDomain },
        });
    } else {
        dispatch({
            type: SELECTED_DOMAIN,
            data: { selectedDomain: responseDomain },
        });
    }
    // dispatch(getVoipStatus());
    dispatch({
        type: DOMAIN_RECEIVED,
        data: { domains: { domains: domainsList } },
    });
}
export const setCallHistory = (selectedContactId) => (dispatch) => {
    if (selectedContactId) {
        getCallHistoryForSelectedContact(selectedContactId).then((callHistory) => {
            dispatch({
                type: UPDATE_SELECTED_CONTACT_CALL_HISTORY,
                payload: {
                    callHistory,
                    selectedContactId,
                },
            });
        });
    }
};


export const clearLoggedInUserCallHistory = () => {
    return {
        type: CLEAR_LOGGED_IN_USER_CALL_HISTORY,
    };
};

// export function getAllDomains() {
// 	return async (dispatch) => {
// 		try {
// 			let domainsList = await getDataFromLFStorage(LFStorageKeys.DOMAINS);
// 			if (!domainsList?.length) {
// 				let domainsListRes = await authFunctions.getDomainUser();
// 			if (domainsListRes) {
// 					let fetchedDomains = domainsListRes.domains;
// 					if (getSignupPath() !== "/login") {
// 						domainsList = fetchedDomains.filter(
// 							(domain) => domain.userDomain !== FRONTM_DOMAIN
// 						);
// 						loadAllDomainsListInLFStorage(fetchedDomains);
// 					} else {
// 						loadAllDomainsListInLFStorage(fetchedDomains);
// 					}
// 					setAllDomains(fetchedDomains,dispatch);
// 				}
// 			}
// 			setAllDomains(domainsList,dispatch);


// 		} catch (error) {
// 			console.error("%c Error in getAllDomains: ", "color: red;", error);
// 		}
// 	};
// }
export const getLoggedInUserCallHistory =
    (startTime) => (dispatch, getState) => {
        const timeStamp =
            startTime ||
            getState().user.timeStampOfLastRecordInExCallHistoryForLoggedInUser;
        const selectedDomainState = getState().domain?.selectedDomain || ""
        const domainName = selectedDomainState || ""
        getPaginatedCallHistory(timeStamp, domainName)
            .then((callHistory) => {
                dispatch({
                    type: UPDATE_LOGGED_IN_USER_CALL_HISTORY,
                    payload: {
                        records: callHistory?.records,
                        moreRecordsExist: callHistory?.moreRecordsExist,
                    },
                });
            })
            .catch((error) => {
                console.error("Cannot fetch logged in user Call History", error);
            });
    };


export function closeBanner() {
    return {
        type: UPDATE_BANNER,
        data: {
            bannerType: null,
            message: null,
        },
    };
}

export function sendMsgForBanner(bannerType, msg) {
    return {
        type: UPDATE_BANNER,
        data: {
            bannerType: bannerType,
            message: msg,
        },
    };
}

export const logoutUser = () => ({
    type: LOGOUT_USER,
});

export function updateSoftwareMfaEnabled(data) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_SOFTWARE_MFA,
            data,
        });
    };
}

export function updateSoftwareMfaStatus(status) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_SOFTWARE_MFA_STATUS,
            status,
        });
    };
}

export function updateMFAStatus(data) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_MFA_STATUS,
            data: { mfaStatus: data },
        });
    };
}

export function updateQrCodeUri(data) {
    return (dispatch) => {
        dispatch({
            type: UPDATE_QR_CODE_URI,
            data,
        });
    };
}

export const setPhoneBalance = (payload) => ({
    type: UPDATE_PHONE_BALANCE,
    payload,
});

export const setUserOnlineStatus = (payload) => (dispatch) => {
    if (payload) {
        dispatch(setBannerVisibility(false));
        setUserOnline(true);
        setTimeout(() => {
            // dequeueFileUpload();
            dispatch(streamChatMessages());
        }, 30000);
    } else {
        setUserOnline(false);
        dispatch(setBannerVisibility(true));
    }
    // AudioElement.pauseBeep();
    dispatch({
        type: USER_ONLINE_STATUS,
        payload,
    });
};
export function pushNotificationsApiRequest(data) {
    let { currentUserDomain, sessionId, webPushAppType, userEmail, baseURL, deregister } =
        data;
    let pushKey;
    if (
        currentUserDomain === VIKAND || currentUserDomain === VIKAND_DIRECT || currentUserDomain === VIKAND_DIRECT_STAGE
    ) {
        pushKey = Config.vikandWebPushKey;
    }

    if (currentUserDomain === SEAMEDEX_TYPE) {
        pushKey = Config.seamedexWebPushKey;
    }

    const config = {
        pushKey,
    };

    // Early return if pushKey is not defined for this domain
    if (!config.pushKey) {
        console.warn("Push notification not available for this domain:", currentUserDomain);
        return;
    }

    async function subscribe() {
        navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {

            serviceWorkerRegistration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlB64ToUint8Array(config.pushKey),
            }).then((subscription) => {
                console.log("<=============== SUBSCRIPTION ============>", subscription)
                const subscriptionData = JSON.stringify(subscription);
                const subscriptionInfo = JSON.parse(subscriptionData);
                if (!subscription) {
                    navigator.serviceWorker.ready.then((reg) => {
                        reg.pushManager.getSubscription().then((subscription) => {
                            if (subscription) {
                                subscription?.unsubscribe()
                                    .then((successful) => { })
                                    .catch((e) => { });
                            }

                        });
                    });
                }

                if (subscription) {
                    // Posting a request to grpc using axios once we get the subscription
                    const info = deregister ? {
                        endpoint: subscriptionInfo?.endpoint,
                    } : {
                        endpoint: subscriptionInfo?.endpoint,
                        keys: subscriptionInfo?.keys
                    };
                    let data = JSON.stringify({
                        subscription: JSON.stringify(info),
                        webPushAppType: webPushAppType,
                    });

                    let config = {
                        method: "post",
                        url: baseURL,
                        headers: {
                            "Content-Type": "application/json",
                            sessionId: sessionId,
                        },
                        data: data,
                    };

                    axios(config)
                        .then(function (response) {
                            console.log("Notificaiton API Success", response)
                        })
                        .catch(function (error) {
                            console.log("Notification API error", error)
                            console.log("Notification API error response", error?.response)
                        });
                }
            }).catch((err) => {
                console.log("Failed to subscribe the user: ", err);
                navigator.serviceWorker.ready.then((reg) => {
                    reg.pushManager.getSubscription().then((subscription) => {
                        if (subscription) {
                            subscription?.unsubscribe()
                                .then((successful) => {
                                    subscribe()
                                })
                                .catch((e) => { });
                        }

                    });
                });
            });
        });
    }
    function urlB64ToUint8Array(base64String) {
        const padding = "=".repeat((4 - (base64String?.length % 4)) % 4);
        const base64 = (base64String + padding)
            .replace(/\-/g, "+")
            .replace(/_/g, "/");

        const rawData = window?.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }
    subscribe(userEmail);
}
export function pushNotificationGenerator(data) {
    return {
        type: GENERATING_PUSH_NOTIFICATIONS,
        data,
    };
}

export function pushNotificationDegerator(data) {
    return {
        type: DE_GENERATING_PUSH_NOTIFICATIONS,
        data,
    };
}

export function setConnectionId(data) {
    return {
        type: SET_CONNECTION_ID,
        data,
    };
}